import api from './api';

const supportDashboardService = {
  getDashboardStats: async () => {
    try {
      const response = await api.get('/support-dashboard/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching support dashboard stats:', error);
      throw error;
    }
  },
};

export default supportDashboardService;
